// https://support.microsoft.com/en-us/office/pmt-function-f30c80b4-7710-4959-b10b-498c3a5a8a55
// https://gist.github.com/ahmadjoya/daa6b6f5deca44a0d628349b8b90147f
export const PMT = (ir, np, pv, fv, type) => {
  /*
   * ir   - interest rate per month
   * np   - number of periods (months)
   * pv   - present value
   * fv   - future value
   * type - when the payments are due:
   *        0: end of the period, e.g. end of month (default)
   *        1: beginning of period
   */
  var pmt, pvif;

  fv || (fv = 0);
  type || (type = 0);

  if (ir === 0) {
    return -(pv + fv) / np;
  }

  pvif = Math.pow(1 + ir, np);
  pmt = (-ir * (pv * pvif + fv)) / (pvif - 1);

  if (type === 1) {
    pmt /= 1 + ir;
  }

  return pmt;
};

function parseNumber(string) {
  if (string instanceof Error) {
    return string;
  }
  if (string === undefined || string === null || string === '') {
    return 0;
  }
  if (typeof string === 'boolean') {
    string = +string;
  }
  if (!isNaN(string)) {
    return parseFloat(string);
  }
  return string;
}

function anyIsError() {
  var n = arguments?.length;
  while (n--) {
    if (arguments[n] instanceof Error) {
      return true;
    }
  }
  return false;
}

var num = new Error('#NUM!');

// https://support.microsoft.com/en-us/office/rate-function-9f665657-4a7e-4bb7-a030-83fc59e748ce
// https://gist.github.com/kucukharf/677d8f21660efaa33f72 + the help of formula js library https://github.com/formulajs/formulajs
// The algorithm below is edited. The guess is changed to 0.1 instead of 0.01 since 0.01 fails on some test cases
export const RATE = (periods, payment, present, future, type, guess) => {
  guess = guess === undefined ? 0.1 : guess;
  future = future === undefined ? 0 : future;
  type = type === undefined ? 0 : type;
  periods = parseNumber(periods);
  payment = parseNumber(payment);
  present = parseNumber(present);
  future = parseNumber(future);
  type = parseNumber(type);
  guess = parseNumber(guess);
  if (anyIsError(periods, payment, present, future, type, guess)) {
    // return value;
  }
  var epsMax = 1e-10;
  var iterMax = 20;
  var rate = guess;
  type = type ? 1 : 0;
  for (var i = 0; i < iterMax; i++) {
    if (rate <= -1) {
      return num;
    }
    var y = void 0,
      f = void 0;
    if (Math.abs(rate) < epsMax) {
      y = present * (1 + periods * rate) + payment * (1 + rate * type) * periods + future;
    } else {
      f = Math.pow(1 + rate, periods);
      y = present * f + payment * (1 / rate + type) * (f - 1) + future;
    }
    if (Math.abs(y) < epsMax) {
      return rate;
    }
    var dy = void 0;
    if (Math.abs(rate) < epsMax) {
      dy = present * periods + payment * type * periods;
    } else {
      f = Math.pow(1 + rate, periods);
      var df = periods * Math.pow(1 + rate, periods - 1);
      dy =
        present * df + payment * (1 / rate + type) * df + payment * (-1 / (rate * rate)) * (f - 1);
    }
    rate -= y / dy;
  }
  return rate;
};

// This class will make it easy for us to create inputs instances that are returned from the BE
export class InputField {
  constructor(
    label = '',
    subLabel = '',
    defaultValue = 0,
    min = 0,
    max = 0,
    maxLength = 0,
    placeholder = '',
    step = 1,
    adornment = ''
  ) {
    this.label = label;
    this.subLabel = subLabel;
    this.defaultValue = defaultValue;
    this.min = min;
    this.max = max;
    this.maxLength = maxLength;
    this.placeholder = placeholder;
    this.step = step;
    this.adornment = adornment;
  }
}

export const isNumber = (num) => {
  return typeof num === 'number';
};
